import { useCallback, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';
import { useUserSubscriptions } from '../queries/SubscriptionQueries';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

export default function AdComponent() {
  const location = useLocation();
  const { data, isLoading } = useUserSubscriptions();

  const showAds = useMemo(() => {
    if (
      location.pathname === '/' ||
      location.pathname === '/register' ||
      location.pathname === '/forgotpassword' ||
      location.pathname === '/resetpassword' ||
      location.pathname === '/privacy-policy' ||
      location.pathname === '/terms-of-use' ||
      isLoading ||
      data?.isAdFree === true
    ) {
      return false;
    }
    return true;
  }, [location.pathname, data, isLoading]);

  const handleAds = useCallback(() => {
    if (!document.getElementById('adsbygoogleaftermount')) {
      const script = document.createElement('script');
      script.id = 'adsbygoogleaftermount';
      script.type = 'text/javascript';
      script.async = true;
      script.src =
        'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
      document.head.appendChild(script);
    }
    if (!showAds) return;
    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
    } catch {
      console.error('Error loading :');
    }
  }, [showAds]);

  useEffect(() => {
    handleAds();
  }, [handleAds, location.key, showAds]);

  return (
    <div key={location.key}>
      <div className='px-2 w-full min-h-[90px] min-w-[300px] flex justify-center'>
        {showAds && (
          <ins
            className='adsbygoogle min-h-[90px] min-w-[300px] max-w-[1200px] w-full'
            style={{ display: 'block', margin: 'auto' }}
            data-ad-client='ca-pub-9453781066915703'
            data-ad-slot='1328159277'
            data-ad-format='auto'
            data-full-width-responsive='true'
          ></ins>
        )}
      </div>
    </div>
  );
}
